// extracted by mini-css-extract-plugin
export default {"label":"DzjE7Q"};